import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { MBOOK_ORGANISATION_ID, strings } from '@constants'
import { getAllAccountDetails, updateOrganisationApi } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Select } from '@baseV2'

import { InputsWrapper } from '../styles'

const BankForm = ({ data, update, financialData }) => {
	const dispatch = useDispatch()
	const user = useSelector((state) => state.getIn(['user', 'user']))

	const [accounts, setAccounts] = useState([])
	const [bank, setBank] = useState({})

	useEffect(() => {
		dispatch(showLoader(true))
		getAllAccountDetails(MBOOK_ORGANISATION_ID, user?.user_id)
			.then((res) => setAccounts(Array.isArray(res?.account_details) ? res.account_details : []))
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, strings('msg_failed_to_fetch'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data?.organisation_id])

	useEffect(() => {
		const saved = financialData?.mbook_bank
		if (!saved || accounts?.length === 0) return
		setBank(
			accounts.find((item) =>
				saved?.account_number ? item?.account_number === saved?.account_number : item?.account_number === saved?.account_number
			) || {}
		)
	}, [financialData, accounts])

	const buttonHandler = () => {
		dispatch(showLoader(true))
		updateOrganisationApi(data.organisation_id, 'MBOOK_BANK', null, {
			bankName: bank?.bank_name,
			accountId: bank?.account_id,
			accountNumber: bank?.account_number,
			ifscCode: bank?.ifsc_code,
			name: bank?.name,
		})
			.then(() => {
				dispatch(showToast(true, strings('organisation_update_success'), { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				update()
			})
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, strings('organisation_update_failure'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Select
						id='mbook-bank-v2'
						label={strings('select', 'bank')}
						placeholder={strings(['select', 'bank'])}
						data={accounts}
						displayKey='name'
						primaryKey='account_number'
						value={bank ?? {}}
						onChange={setBank}
					/>
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' disabled={!bank?.account_number} onClick={buttonHandler}>
					{strings('update')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default BankForm
